import { render, staticRenderFns } from "./Register-aviso.vue?vue&type=template&id=d221bd04&"
import script from "./Register-aviso.vue?vue&type=script&lang=js&"
export * from "./Register-aviso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports